export enum EntityType {
  COPY_LINK = 'COPY_LINK',
  VIEW_DWF_FILE = 'VIEW_DWF_FILE',
  VIEW_COPY_LINK = 'VIEW_COPY_LINK',
  VIEW_AO_RESPONSE = 'VIEW_AO_RESPONSE',
  VIEW_RESPONSE = 'VIEW_RESPONSE',
  OPEN_ISEEKPLANT_LINK = 'OPEN_ISEEKPLANT_LINK',
  OPEN_FIRE_ANTS_LINK = 'OPEN_FIRE_ANTS_LINK',
  VIEW_ATTACHMENT = 'VIEW_ATTACHMENT',
  VIEW_LUAL = 'VIEW_LUAL',
  OPEN_LUAL_LINK = 'OPEN_LUAL_LINK'
}

interface ActionTypes {
  SUBMIT_EVENT: string;
  TRACK_EVENT_COMPLETED: string;
}

export const TrackActionTypes: ActionTypes = {
  SUBMIT_EVENT: '@@SUBMIT_EVENT',
  TRACK_EVENT_COMPLETED: '@@TRACK_EVENT_COMPLETED'
};

export interface PayloadTypes {
  type: EntityType;
  payload: any;
}

export interface TrackState {
  trackCounter: number;
}
